import Vue from 'vue'
import App from './App.vue'
import Notifications from "vue-notification";
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from "axios";
import VModal from 'vue-js-modal'

Vue.config.productionTip = false
Vue.use(Notifications);
Vue.use(VModal, { dialog: true })

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    store.state.isLoading = false;
    if (error.response) {
      if (error.response.status === 401) { // Token Expired
        store.state.isTokenExpired = {
          event: new Date().getTime(),
          expired: true
        }  
      } else {
        if (error.response.data && error.response.data.errcode) {
          store.state.notifications = {
            type: "error",
            title: "Service Error",
            message: error.response.data.message,
            eventTime: new Date()
          }
        } else {
          store.state.notifications = {
            type: "error",
            title: "Unknown Error",
            message: "Unknow Error was occured!",
            eventTime: new Date()
          }
          console.log(error.response);
        }
      }
    }
  }
);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
